import Store from "@/store/index.js";
import axios from 'axios'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
const domain = Store.state.domain;

export default {
    async Telefonos(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTelefonos`, datosReporte);
        return response.data;
    },
    async Notification(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerNotificacion`, datosReporte);
        return response.data;
    },
    async ObtenerMsjs(vm, tel, nrreporte, svindice,actualizaNot) {

        var datosReporte = new FormData();
        datosReporte.append("telefono", tel);
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        datosReporte.append("actualizaNot", actualizaNot);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerMensajes`, datosReporte);
        return response.data;
    },

    async ObtenerEncabezado(vm, telefono, datos) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", telefono);
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerEncabezado`, datosReporte);
        return response.data;
    },
    async CambiarIdioma(vm, telefono, idioma) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", telefono);
        datosReporte.append("idioma", idioma);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/CambiarIdioma`, datosReporte);
        return response.data;
    },
    async ObtenerTelefonosAbogado(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTelefonosAbogado`, datosReporte);
        return response.data;
    },
    async ObtenerMultimediaAmazon(vm, ruta, archivo) {
        var formData = new FormData();
        formData.append("ruta", ruta);
        formData.append("archivo", archivo);
        return vm.axios.post(`${vm.domain.domainNameForApi}Whatsapp/DescargarArchivosAmazon`, formData).then(response => response);

    },
    async EnviarMensaje(vm, mensaje, numTelefono, numTelFormatted, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("mensaje", mensaje);
        datosReporte.append("numTelefono", numTelefono);
        datosReporte.append("numTelFormatted", numTelFormatted);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/EnviarMensaje`, datosReporte);
        return response.data;
    },
    async ReactToMessage(vm, mensaje, numTelefono, numTelFormatted, idmsg) {
        var datosReporte = new FormData();
        datosReporte.append("mensaje", mensaje);
        datosReporte.append("numTelefono", numTelefono);
        datosReporte.append("numTelFormatted", numTelFormatted);
        datosReporte.append("idmsg", idmsg);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ReactToMessage`, datosReporte);
        return response.data;
    },
    async EnviarMultimedia(vm, numTelefono, numTelFormatted, file, tipo, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("numTelefono", numTelefono);
        datosReporte.append("numTelFormatted", numTelFormatted);
        datosReporte.append("Archivo", file);
        datosReporte.append("tipo", tipo);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/EnviarMultimedia`, datosReporte)
        return response.data;
    },
    async ObtenerMensajesNuevos(vm, tel, lastIndex, nrreporte, svindice, actualizaNot) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", tel);
        datosReporte.append("lastIndex", lastIndex);
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        datosReporte.append("actualizaNot", actualizaNot);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerMensajesNuevos`, datosReporte)
        return response.data;
    },
    async ObtenerNuevoEstatusMensaje(vm, messageId) {
        var formData = new FormData();
        formData.append("messageId", messageId);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/StatusMensajes`, formData)
        return response.data;
    },
    async ObtenerNuevoEmojie(vm, messageId) {
        var formData = new FormData();
        formData.append("messageId", messageId);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerEmojie`, formData)
        return response.data;
    },
    async ObtenerContenidoMultimedia(vm, mediaURL) {
        var formData = new FormData();
        formData.append("mediaURL", mediaURL);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Whatsapp/ContenidoMultimedia`, formData)
        return response.data;
    },
    async ObtenerTotalMensajes(vm, tel, nrreporte, svindice) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", tel);
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTotalMensajes`, datosReporte)
        return response.data[0];
    },
    async ObtenerMensajesPaginados(vm, tel, index, nrreporte, svindice) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", tel);
        datosReporte.append("index", index);
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerMensajesPaginados`, datosReporte)
        return response.data;
    },
    async RegistrarLectura(vm, tel, primerMsj, ultimoMsj, nrreporte, svindice) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", tel);
        datosReporte.append("primerMsj", primerMsj);
        datosReporte.append("ultimoMsj", ultimoMsj);
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/RegistrarLectura`, datosReporte)
        return response.data;
    },
    async RegistrarMsjLeido(vm, tel, lastIndex) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", tel);
        datosReporte.append("lastIndex", lastIndex);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/RegistrarUltimoMsjLeido`, datosReporte)
        return response.data;
    },
    async ObtenerTextoRespuesta(vm, replyId) {
        var formData = new FormData();
        formData.append("replyId", replyId);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTextoRespuesta`, formData)
        return response.data;
    },
    async ObtenerTelefonosSupervisor(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTelefonosSupervisor`, datosReporte)
        return response.data;
    },
    async ObtenerReportes(vm, tel, nrreporte, svindice) {
        var datosReporte = new FormData();
        datosReporte.append("telefono", tel);
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerReportes`, datosReporte);
        vm.Reportes.opcionesReportes = response.data;
    },
    async TelefonosNoWS(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTelefonosNoWS`, datosReporte);
        return response.data;
    },
    async TemplatesWS(vm, actor, datos, tipo) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("actor", actor);
        datosReporte.append("tipo", tipo);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTemplates`, datosReporte);
        return response.data;
    },
    async IniciarConversacion(vm, telefono, actor, datos) {

        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("tel", telefono);
        datosReporte.append("actor", actor);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/IniciarConversacion`, datosReporte);
        return response.data;
    },
    async ClasificarMensajes(vm, nrreporte, svindice, tel, mensajes) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        datosReporte.append("telefono", tel);
        datosReporte.append("mensajes", mensajes);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ClasificarMensajes`, datosReporte);
        return response.data;
    },
    async ObtenerTelefonosHistorial(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTelefonosHistorial`, datosReporte)
        return response.data;
    },
    async TemplateConversacion(vm, telefono, ntclave, datos) {

        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("tel", telefono);
        datosReporte.append("ntclave", ntclave);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/TemplateConversacion`, datosReporte);
        return response.data;
    },
    async ObtenerReportesAsociados(vm, telefono, nrreporte, svindice) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        datosReporte.append("telefono", telefono);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerReportesAsociados`, datosReporte);
        vm.ReportesDoc.opcionesReportes = response.data;
    },
    async ObtenerCatalogo(vm, nrreporte, svindice, aiclave, typefile) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        datosReporte.append("aiclave", aiclave);
        datosReporte.append("typefile", typefile);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerCatalogo`, datosReporte);
        vm.Documentos.opcionesDocumentos = response.data;
    },
    async AdjuntarArchivoAlReporte(vm, idBubble, nrreporte, svindice, doclave, mediaType, attachFileName, mediaURL, base64audio) {
        var datosReporte = new FormData();
        datosReporte.append("idBubble", idBubble);
        datosReporte.append("nrreporte", nrreporte);
        datosReporte.append("svindice", svindice);
        datosReporte.append("doclave", doclave);
        datosReporte.append("mediaType", mediaType);
        datosReporte.append("attachFileName", attachFileName);
        datosReporte.append("mediaURL", mediaURL);
        datosReporte.append("base64audio", base64audio);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/AdjuntarArchivoAlReporte`, datosReporte);
        console.log("response service", response)
        return response;
    },
    async ObtenerTelefonosHistorialAgentes(vm, datos) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerTelefonosHistorialAgentes`, datosReporte)
        return response.data;
    },
    async ValidarRuta(vm, idBubble) {
        var datosReporte = new FormData();
        datosReporte.append("idBubble", idBubble);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ValidarRuta`, datosReporte);
        return response.data;
    },
    async ObtenerVistos(vm, idMsj) {


        var datosReporte = new FormData();
        datosReporte.append("idMsj", idMsj);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ObtenerVistos`, datosReporte);
        return response.data;
    },
    async ObtenerPendientes() {
        const res = await axios.post(`${domain.domainNameForApi}WhatsApp/ObtenerNotificacionesPendientes`);
        return res.data
    },
    async ValidarTemplateCalidad(vm, actor) {
        var datosReporte = new FormData();
        datosReporte.append("actor", actor);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}WhatsApp/ValidarTemplateCalidad`, datosReporte);
        return response.data;
    },
}